<div [hidden]="hide">
    <div class="loader">
        <i class="glyphicon glyphicon-cog spin"></i>
        <div>Einen Augenblick...</div>
    </div>
</div>